import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import contactsStyle from './Contacts.module.scss';
import ProtfolioStore from '../../stores/protfolio/Protfolio.store';
import { PROTFOLIO_STORE } from '../../stores/constants';
import rootStores from '../../stores/index';
import ContactMeForm from '../../components/contactMeForm/ContactMeForm';
import SectionHeading from '../../components/elements/sectionHeading/SectionHeading';
import { ISendEmailPayload } from '../../interfaces/interfaces';
import ClientConfig, { primarySocials } from '../../config';
import { profile } from '../../data/profile';
import { BLANK } from '../../constants/constants';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';

const protfolioStore = rootStores[PROTFOLIO_STORE] as ProtfolioStore;

const Contacts = observer(() => {
    const { sendEmail } = protfolioStore;
    const { t } = useTranslation();

    const sumbitFormHandler = (payload: ISendEmailPayload) => {
        sendEmail(payload);
    };

    const channels = [
        {
            icon: <MailOutlineIcon />,
            label: t('contacts.email'),
            value: ClientConfig.email,
            href: `mailto:${ClientConfig.email}`,
        },
        {
            icon: <PhoneOutlinedIcon />,
            label: t('contacts.phone'),
            value: ClientConfig.phoneNumber,
            href: `tel:${ClientConfig.phoneNumber.replace(/-/g, '')}`,
        },
        {
            icon: <PlaceOutlinedIcon />,
            label: t('contacts.basedIn'),
            value: profile.location,
            href: '',
        },
    ];

    return (
        <section className={contactsStyle.section}>
            <div className={contactsStyle.inner}>
                <SectionHeading eyebrow={t('contacts.eyebrow')} title={t('contacts.title')} description={t('contacts.description')} />

                <div className={contactsStyle.layout}>
                    <aside className={contactsStyle.channels}>
                        {channels.map((channel) => {
                            const content = (
                                <>
                                    <span className={contactsStyle.channelIcon}>{channel.icon}</span>
                                    <span className={contactsStyle.channelText}>
                                        <span className={contactsStyle.channelLabel}>{channel.label}</span>
                                        <span className={contactsStyle.channelValue}>{channel.value}</span>
                                    </span>
                                </>
                            );

                            return channel.href ? (
                                <a key={channel.label} className={contactsStyle.channel} href={channel.href}>
                                    {content}
                                </a>
                            ) : (
                                <div key={channel.label} className={contactsStyle.channel}>
                                    {content}
                                </div>
                            );
                        })}

                        <div className={contactsStyle.socials}>
                            <span className={contactsStyle.socialsLabel}>{t('footer.elsewhere')}</span>
                            <div className={contactsStyle.socialsRow}>
                                {primarySocials.map((social, i) => (
                                    <button
                                        key={i}
                                        type='button'
                                        className={contactsStyle.socialButton}
                                        onClick={() => window.open(social.url, BLANK, 'noopener,noreferrer')}
                                        aria-label={social.label}
                                        title={social.label}
                                    >
                                        {React.cloneElement(social.icon, { className: contactsStyle.socialIcon })}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </aside>

                    <div className={contactsStyle.formCard}>
                        <ContactMeForm sumbitFormHandler={sumbitFormHandler} />
                    </div>
                </div>
            </div>
        </section>
    );
});

export default Contacts;
